"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
/**
 * This script controls only the visual state of the checkboxes corresponding to the radio buttons on the "Product" page.
 * The actual filter logic is located in the "Filter.ts" script.
 */
var ProductFilter = /** @class */ (function (_super) {
    __extends(ProductFilter, _super);
    function ProductFilter() {
        var _this = _super.call(this, constants_1.DATA_FILTER) || this;
        if (!_this.getElement())
            return _this;
        _this.filterRadioBtns = _this.getElement().querySelectorAll("[".concat(constants_1.DATA_FILTER_CHANGE_RADIO, "]"));
        _this.filterWrap = _this.getElement().querySelector("[".concat(constants_1.DATA_FILTER_CHECKBOX_WRAP, "]"));
        _this.filterApplications = _this.getElement().querySelectorAll("[".concat(constants_1.DATA_APPLICATIONAREAS, "]"));
        _this.filterHint = _this.getElement().querySelector("[".concat(constants_1.DATA_FILTER_HINT_WRAP, "]"));
        _this.initEventListeners();
        return _this;
    }
    /**
     * Init listeners
     * @private
     */
    ProductFilter.prototype.initEventListeners = function () {
        var _this = this;
        this.filterRadioBtns.forEach(function (element) {
            element.addEventListener('change', function () {
                _this.showHideCheckboxes();
            });
        });
    };
    ProductFilter.prototype.showHideCheckboxes = function () {
        var _this = this;
        // Get the selected application area
        this.filterSelectedRadio = this.getElement().querySelector("[".concat(constants_1.DATA_FILTER_CHANGE_RADIO, "]:checked"));
        var radioVal = this.filterSelectedRadio.value;
        // Hide filter content if no application is selected
        if (radioVal != undefined) {
            this.filterWrap.classList.remove(constantsClasses_1.CLASS_HIDDEN);
        }
        this.filterApplications.forEach(function (element) {
            var checkboxConditionsJson = element.getAttribute(constants_1.DATA_APPLICATIONAREAS);
            var checkboxConditions = JSON.parse(checkboxConditionsJson);
            element.classList.add(constantsClasses_1.CLASS_HIDDEN);
            element.querySelector('[data-filter-change]').checked = false;
            //Getting checkbox values from JSON array
            for (var key in checkboxConditions) {
                if (checkboxConditions[key] == radioVal) {
                    element.classList.remove(constantsClasses_1.CLASS_HIDDEN);
                    _this.filterHint.classList.add(constantsClasses_1.CLASS_HIDDEN);
                }
            }
        });
    };
    return ProductFilter;
}(AbstractComponent_1.default));
exports.default = ProductFilter;
